import network from "./utils/network";
import PageLoading from "./components/module/loading/PageLoading";
import { EVENTS } from "./utils/eventBus";
import PortalOther from "@/views/Other.vue";
import { changeTheme, getCurrentTheme, localFetch, tenantIdFromPath } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import { loadLanguageAsync } from "@/plugins/i18n";
import PortalError from "@/views/Error.vue";
import { defineAsyncComponent } from "vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Toast from "primevue/toast";
export default {
  name: "PortalHome",
  methods: {
    getCurrentTheme
  },
  components: {
    AppLayout,
    PortalError,
    PortalOther,
    PageLoading,
    Toast,
    LoadingIndicator: defineAsyncComponent(() => import("@/components/module/loading/LoadingIndicator"))
  },
  computed: {
    tenantIdFromPath,
    UI_THEMES() {
      return UI_THEMES;
    },
    isLoginLayout() {
      return this.$route.meta ? this.$route.meta.loginLayout : false;
    },
    showSidebar() {
      return !this.$route.meta || !this.$route.meta.hideSidebar;
    },
    configLoaded() {
      return this.$store.getters["uiConfigStore/isLoaded"] || ["SignIn", "Other", "NotFound"].includes(this.$route.name);
    }
  },
  async created() {
    this.tenantId = this.tenantIdFromPath;
    network.configure(this.$store, this.$router, this.$toast);
    const axios = network.createAxiosInstance();
    this.$store.commit("uiConfigStore/setCurrentTheme", localFetch("current_ui_theme"));
    changeTheme(localFetch("current_ui_theme"));

    // eventBus.$on(EVENTS.PAGE_LOADING, () => (this.pageLoaded = false));
    // eventBus.$on(EVENTS.PAGE_LOADED, () => (this.pageLoaded = true));

    await this.$store.dispatch("env/fetch");
    let storedLocale = localFetch("stored_locale");
    if (storedLocale) {
      await loadLanguageAsync(storedLocale);
    } else if (this.$store.getters["session/isReady"]) {
      await this.$store.dispatch("census_user/fetchProfile");
      const fetchedLocale = this.$store.getters["census_user/profile"]?.lang;
      if (fetchedLocale) {
        await loadLanguageAsync(fetchedLocale);
      }
    } else {
      // default lang
      await loadLanguageAsync("hu");
    }
    if (this.$route.name === "Onboarding") {
      this.onboardingPage = true;
      return;
    }
    if (this.tenantId) {
      try {
        await this.$store.dispatch("uiConfigStore/fetch", this.tenantId);
        this.validTenant = true;
        document.querySelector('link[rel="icon"]').setAttribute("href", process.env.VUE_APP_FAVICON);
      } catch (e) {
        this.validTenant = false;
      } finally {
        this.tenantExamined = true;
      }
    } else {
      this.tenantExamined = true;
    }
    if (this.$store.getters["session/isReady"]) {
      await Promise.all([await this.$store.dispatch("employee/fetchEmployees")]);
    }
  },
  data() {
    return {
      EVENTS,
      pageLoaded: true,
      tenantId: null,
      tenantExamined: false,
      validTenant: false,
      onboardingPage: false
    };
  }
};